module.exports = "/_next/static/images/rw-85f6ca97a21f7c3ae7b1a81735ebbc20.svg";